import { createContext } from 'react';

import type { WagmiConnectState } from './types';

export const WagmiConnectStateContext = createContext({} as WagmiConnectState);
